import { AchievementName } from '@helios/achievement';
import { ApiUser } from '../../../api/user/types';
import { TakeoverId } from '../../../hooks/useTakeover';
import { ROUTE } from '../../../routes';
import { OpenTakeover } from '../../_app/TakeoverProvider/TakeoverContext';

export interface BadgeDetailDescriptionConfig {
  locale: string;
  url?: string;
  args?: Record<string, unknown>;
  onClick?: (context: { user: ApiUser; propertyId?: string; openTakeover: OpenTakeover }) => void;
}

export const badgeDetailDescriptionMap: Record<AchievementName, BadgeDetailDescriptionConfig> = {
  'data-pioneer': { locale: 'badge.detail.link.completeYourProfile', url: ROUTE.ENERGY_PROFILE },
  'data-powered': {
    locale: 'badge.detail.link.connectUtilityProvider',
    onClick: ({ propertyId, openTakeover }) => {
      openTakeover(TakeoverId.UTILITY_CONNECT, { propertyId });
    },
  },
  'fast-learner': { locale: 'badge.detail.energyGoal' },
  'streak-rookie': { locale: 'badge.detail.energyGoalStreak' },
  '4-week-streak': { locale: 'badge.detail.energyGoalStreak' },
  '6-week-streak': { locale: 'badge.detail.energyGoalStreak' },
  '8-week-streak': { locale: 'badge.detail.energyGoalStreak' },
  'streak-pro': { locale: 'badge.detail.energyGoalStreak' },
  'exported-50-kwh': { locale: 'badge.detail.solarExport' },
  'exported-100-kwh': { locale: 'badge.detail.solarExport' },
  'exported-300-kwh': { locale: 'badge.detail.solarExport' },
  'exported-500-kwh': { locale: 'badge.detail.solarExport' },
  'exported-700-kwh': { locale: 'badge.detail.solarExport' },
  'exported-1000-kwh': { locale: 'badge.detail.solarExport' },
  'weekly-warrior': { locale: 'badge.detail.useEnergyAction' },
  'power-user': { locale: 'badge.detail.useEnergyAction' },
  'trivia-first-correct': { locale: 'badge.detail.triviaStreak' },
  'trivia-streak-5': { locale: 'badge.detail.triviaStreak' },
  'trivia-streak-10': { locale: 'badge.detail.triviaStreak' },
  'trivia-streak-15': { locale: 'badge.detail.triviaStreak' },
  'trivia-streak-20': { locale: 'badge.detail.triviaStreak' },
  'trivia-streak-30': { locale: 'badge.detail.triviaStreak' },
  'trivia-streak-50': { locale: 'badge.detail.triviaStreak' },
  'trivia-streak-100': { locale: 'badge.detail.triviaStreak' },
  'solar-pro': { locale: 'badge.detail.completeQuest' },
  'hvac-expert': { locale: 'badge.detail.completeQuest' },
  'battery-savvy': { locale: 'badge.detail.completeQuest' },
};
